import React from "react";
import Typography from "@mui/material/Typography";

type AsOfFooterProps = {
  referenceDateString: string;
};

function AsOf(props: AsOfFooterProps) {
  return (
    <Typography
      variant="subtitle2"
      color="text.secondary"
      sx={{ paddingLeft: 1, paddingRight: 1, position: "absolute", bottom: 0, right: 0 }}
    >
      {props.referenceDateString}
    </Typography>
  );
}

export default AsOf;
